import { z } from 'zod';

import { defineService } from '@@api/lib/defineService';
import config from '@@config';

import { HistoryItem } from './schemas';

export const placementHistoryService = defineService(
    (defineEndpoint) => ({
        items: {
            getAll: defineEndpoint({
                method: 'GET',
                path: '/items',
                query: z.object({
                    metadataId: z.number(),
                    tenantId: z.number(),
                }),
                responses: {
                    200: z.array(HistoryItem),
                },
            }),
        },
    }),
    {
        baseUrl: config.apiEnvVars.placementHistoryUrl,
    },
);
